module.exports = __webpack_public_path__ + "static/ibotta_logo4-cd212e402d0ad69aecf17c1f3e033fc3.png";